/* gk-promo-combo */
if (!customElements.get('gk-promo-combo')) {
  class GkPromoCombo extends HTMLElement {
    connectedCallback() {
      this.classList.add('gkpc--v2');

      this.hEl = this.querySelector('[data-gkpc-h]');
      this.mEl = this.querySelector('[data-gkpc-m]');
      this.sEl = this.querySelector('[data-gkpc-s]');
      this.barFill = this.querySelector('[data-gkpc-bar]');

      // Texto entre parênteses do título vai para uma nota pequena no fundo da caixa
      const label = this.querySelector('.gkpc__label');
      if (label && !this.querySelector('.gkpc__note')) {
        const m = label.textContent.trim().match(/^(.*?)\s*(\([^)]*\))\s*$/);
        if (m && m[1]) {
          label.textContent = m[1];
          const note = document.createElement('p');
          note.className = 'gkpc__note';
          note.textContent = m[2];
          (this.querySelector('.gkpc__inner') || this).appendChild(note);
        }
      }
      // Raio antes de "OFERTA EXCLUSIVA"
      if (label && !label.querySelector('.gkpc__bolt')) {
        const bolt = document.createElement('span');
        bolt.className = 'gkpc__bolt';
        bolt.setAttribute('aria-hidden', 'true');
        bolt.innerHTML =
          '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.2 2 4.5 13.4h6.2L9.8 22l8.7-11.4h-6.2L13.2 2z"/></svg>';
        label.insertBefore(bolt, label.firstChild);
      }
      // "Termina em" antes do cronometro (a bola preta do cronometro fica igual)
      const timer = this.querySelector('.gkpc__timer');
      if (timer && !this.querySelector('.gkpc__ends')) {
        const ends = document.createElement('span');
        ends.className = 'gkpc__ends';
        ends.textContent = 'Termina em';
        timer.parentNode.insertBefore(ends, timer);
      }
      // Aviso discreto, FORA da caixa e logo por baixo: o desconto entra sozinho no carrinho
      const nextEl = this.nextElementSibling;
      if (!(nextEl && nextEl.classList.contains('gkpc__auto')) && this.parentNode) {
        const auto = document.createElement('p');
        auto.className = 'gkpc__auto';
        auto.style.cssText =
          'display:flex;align-items:center;justify-content:center;gap:0.4rem;margin:0 0 1.4rem;font-size:1.1rem;font-weight:500;line-height:1.3;letter-spacing:0.01em;color:#6b7280;text-align:center;';
        auto.innerHTML =
          '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="#22a35a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:0 0 auto"><polyline points="5 12.5 10 17 19 7"/></svg>' +
          '<span>Aplicado automaticamente no carrinho</span>';
        this.parentNode.insertBefore(auto, this.nextSibling);
        this.style.setProperty('margin-bottom', '0.7rem', 'important');
      }

      this.animateDeals();

      this.target = this.calcNextMidnight();
      this.dayMs = 24 * 60 * 60 * 1000;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    // Animação discreta nos botões LEVA/PAGA: brilho que passa e um pequeno "salto" em onda, a cada ~5 s.
    animateDeals() {
      if (this.dataset.gkpcAnim) return;
      const deals = Array.from(this.querySelectorAll('*')).filter((el) => {
        if (!/^\s*leva\s*\d+\s*paga\s*\d+\s*$/i.test(el.textContent || '')) return false;
        const parent = el.parentElement;
        // fica com o maior elemento que ainda é só um botão (o pai já teria vários LEVA)
        return !(parent && parent !== this && /^\s*leva\s*\d+\s*paga\s*\d+\s*$/i.test(parent.textContent || ''));
      });
      if (!deals.length) return;
      this.dataset.gkpcAnim = '1';
      GkPromoCombo.injectAnimStyle();
      deals.forEach((el, i) => {
        el.classList.add('gkpc-deal');
        el.style.setProperty('--gkpc-i', i);
        const shine = document.createElement('span');
        shine.className = 'gkpc-shine';
        shine.setAttribute('aria-hidden', 'true');
        el.appendChild(shine);
      });
      // Contorno com uma luz azul que dá a volta à caixa
      this.classList.add('gkpc-anim');
      const ring = document.createElement('span');
      ring.className = 'gkpc-ring';
      ring.setAttribute('aria-hidden', 'true');
      this.appendChild(ring);
      // Só anima quando a caixa está visível no ecrã; da 1.ª vez os botões entram um a um
      const entrar = () => {
        if (this.dataset.gkpcEntrou) return;
        this.dataset.gkpcEntrou = '1';
        this.classList.add('gkpc-in');
        setTimeout(() => this.classList.remove('gkpc-in'), 1100);
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) entrar();
            this.classList.toggle('gkpc--live', e.isIntersecting);
          });
        }, { threshold: 0.2 });
        io.observe(this);
      } else {
        this.classList.add('gkpc--live');
      }
    }

    static injectAnimStyle() {
      if (document.getElementById('gkpc-anim-css')) return;
      const s = document.createElement('style');
      s.id = 'gkpc-anim-css';
      s.textContent = `
@property --gkpc-a{syntax:'<angle>';initial-value:0deg;inherits:false}
gk-promo-combo.gkpc-anim{position:relative;isolation:isolate}
.gkpc-ring{position:absolute;inset:-1px;border-radius:inherit;padding:2px;pointer-events:none;z-index:2;background:conic-gradient(from var(--gkpc-a),transparent 0 62%,rgba(29,92,255,.15) 70%,#1d5cff 82%,#8fb0ff 88%,transparent 96%);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude;opacity:0;transition:opacity .4s}
.gkpc--live .gkpc-ring{opacity:1;animation:gkpcSpin 3.6s linear infinite}
.gkpc-deal{position:relative;overflow:hidden;transform:translateZ(0);will-change:transform;background-image:linear-gradient(115deg,rgba(255,255,255,0) 30%,rgba(255,255,255,.14) 50%,rgba(255,255,255,0) 70%)!important;background-size:250% 100%!important}
.gkpc-shine{position:absolute;top:0;left:-70%;width:45%;height:100%;pointer-events:none;background:linear-gradient(100deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.6) 50%,rgba(255,255,255,0) 100%);transform:skewX(-20deg)}
.gkpc--live .gkpc-deal{animation:gkpcPop 4.2s cubic-bezier(.34,1.56,.64,1) infinite,gkpcFlow 3s linear infinite;animation-delay:calc(var(--gkpc-i,0) * .14s + .5s),0s}
.gkpc--live .gkpc-shine{animation:gkpcShine 4.2s ease-in-out infinite;animation-delay:calc(var(--gkpc-i,0) * .14s + .5s)}
.gkpc--live .gkpc-deal:first-child{box-shadow:0 0 0 0 rgba(29,92,255,.5)}
.gkpc--live .gkpc__bolt{animation:gkpcBolt 2s ease-out infinite}
.gkpc--live .gkpc__bolt svg{animation:gkpcZap 2s ease-in-out infinite;transform-origin:50% 50%}
.gkpc-in .gkpc-deal{animation:gkpcIn .55s cubic-bezier(.34,1.56,.64,1) both!important;animation-delay:calc(var(--gkpc-i,0) * .09s)!important}
@keyframes gkpcSpin{to{--gkpc-a:360deg}}
@keyframes gkpcFlow{from{background-position:100% 0}to{background-position:-150% 0}}
@keyframes gkpcPop{0%,62%,100%{transform:scale(1) translateY(0)}68%{transform:scale(1.08) translateY(-2px);box-shadow:0 8px 18px rgba(29,92,255,.35)}75%{transform:scale(.98) translateY(0)}80%{transform:scale(1)}}
@keyframes gkpcShine{0%,58%{left:-70%}80%,100%{left:130%}}
@keyframes gkpcBolt{0%{box-shadow:0 0 0 0 rgba(29,92,255,.5)}70%,100%{box-shadow:0 0 0 1rem rgba(29,92,255,0)}}
@keyframes gkpcZap{0%,40%,100%{transform:scale(1) rotate(0)}10%{transform:scale(1.25) rotate(-12deg)}20%{transform:scale(.95) rotate(8deg)}30%{transform:scale(1.1) rotate(0)}}
@keyframes gkpcIn{from{opacity:0;transform:translateY(10px) scale(.92)}to{opacity:1;transform:none}}
@media (prefers-reduced-motion:reduce){.gkpc--live .gkpc-deal,.gkpc--live .gkpc-shine,.gkpc--live .gkpc__bolt,.gkpc--live .gkpc__bolt svg,.gkpc--live .gkpc-ring,.gkpc-in .gkpc-deal{animation:none!important}}
`;
      document.head.appendChild(s);
    }

    calcNextMidnight() {
      const now = new Date();
      const next = new Date(now);
      next.setHours(24, 0, 0, 0);
      return next.getTime();
    }

    tick() {
      const now = Date.now();
      let diff = this.target - now;

      if (diff <= 0) {
        this.target = this.calcNextMidnight();
        diff = this.target - now;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;

      if (this.hEl) this.hEl.textContent = this.pad(h);
      if (this.mEl) this.mEl.textContent = this.pad(m);
      if (this.sEl) this.sEl.textContent = this.pad(s);

      if (this.barFill) {
        // Quanto MAIOR a porcentagem, mais perto da meia-noite (oferta acabando)
        const pct = 100 - (diff / this.dayMs) * 100;
        this.barFill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      }
    }

    pad(n) {
      return String(n).padStart(2, '0');
    }
  }
  customElements.define('gk-promo-combo', GkPromoCombo);
}
